/* eslint-disable import/no-cycle */
import React from "react";
import { Grid } from "@mui/material";
import passwordStrength from "./passwordStrength";
import { PTMInput } from "../index";

export default function PTMPasswordCheck(props) {
    const {
        login, value, changePassword, setError, name, label,
    } = props;
    const [pwStrength, setPwStrength] = React.useState(passwordStrength(value || login?.password || "", {
        allErrors: true,
        minPasswordLength: 10,
        maxConsecutiveRepeatingChars: 3,
    }));
    React.useEffect(() => {
        if (!pwStrength.success) {
            setError(name);
        }
    }, []);
    return (
        <>
            {React.useMemo(() => (
                (changePassword || login?.newLogin) && (
                    <PTMInput
                        fullWidth
                        allowShowPassword={!!login}
                        allowGeneratePassword
                        label={label}
                        name={name}
                        required
                        onChange={(e) => setPwStrength(passwordStrength(e, {
                            allErrors: true,
                            minPasswordLength: 10,
                            maxConsecutiveRepeatingChars: 3,
                        }))}
                        validate={(e) => (/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z\d])(?!.*\s)/).test(e) && e.length > 9}
                    />
                )), [login, changePassword])}
            {!pwStrength.success && (
                <Grid
                    container
                    item
                    xs={12}
                    sx={{
                        bgcolor: "warning.main",
                        // color: pwStrength.color,
                        border: `1px solid ${pwStrength.color}`,
                        marginTop: "5px",
                    }}
                >
                    {pwStrength.message.map((message) => (
                        <Grid item xs={12} ml={2} key={message}>
                            <li>
                                {message}
                            </li>
                        </Grid>
                    ))}
                </Grid>
            )}
        </>
    );
}
